import * as React from "react"
import { Box } from "@mui/material"
import { useEmbargoReportForm } from "../../@hooks";
import { ActionButton } from "@components"


export default function CreateReportButton() {
    const { handleOpenForm, isLoadingDrawer } = useEmbargoReportForm()

    return <Box componet="span" data-tour="embargo-create-report">
        <ActionButton
            isLoading={isLoadingDrawer}
            label="Create New Report"
            icon="pen-to-square"
            onClick={handleOpenForm}
        />
    </Box>
}